// App dependencies
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueApexCharts from 'vue-apexcharts';
import Vuelidate from 'vuelidate';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueMask from 'v-mask';
import VueRouter from 'vue-router';
import vco from "v-click-outside";
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import tinymce from 'vue-tinymce-editor';
import VueScrollTo from 'vue-scrollto';
import moment from 'moment';
import datepicker from 'vue2-datepicker';
import VueCookies from 'vue-cookies';
import { abilitiesPlugin } from '@casl/vue';
import { ability } from './store/ability';

Vue.use(VueRouter);

Vue.use(abilitiesPlugin, ability);
Vue.use(vco);
Vue.use(Scrollspy);
Vue.use(VueScrollTo);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(require('vue-chartist'));
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
  key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
  libraries: 'places',
  },
  installComponents: true
});
Vue.component('apexchart', VueApexCharts);
Vue.component('tinymce', tinymce);
Vue.component('datepicker', datepicker);
Vue.use(VueCookies);
Vue.config.productionTip = false;

Vue.filter('formatDate', function(value) {
  if (value) return moment(String(value)).format('MM/DD/YYYY');
});

// Booting app
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import "@/design/app.scss"
import App from '@/App.vue'

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
